export const STRIP_ITEM_LARGE_WIDTH = 328;
export const STRIP_ITEM_SMALL_WIDTH = 264;
export const STRIP_ITEM_WIDTH_BREAKPOINT = 1365;
export const DEFAULT_TIER_ITEM_HEIGHT = 180;

export const RESIZE_THROTTLE_DELAY = 300;
export const RESIZE_THROTTLE_OPTIONS = { trailing: true };
